import { AuthenticationType } from '@/libs/auth/models/auth-type';

export class SignInModel {
    email: string | null = null;
    password: string | null = null;
    mfaCode: string | null = null;
    authMethod: AuthenticationType = AuthenticationType.Standard;
}

export class SignInTokensModel {
    accessToken: string | null = null;
    refreshToken: string | null = null;
}